import "./styles.scss";

import React from "react";

import Info from "../../../../../Info";

import { getColorVariant } from "utils";

import { headerData } from "data/header";

const Location = () => {
  return (
    <div className="header-mobile-location">
      {headerData.location.data.map((item, index) => (
        <div key={index}>
          <Info title={item.name} variant={getColorVariant(index + 1)}>
            <div>
              {item.hours.map((hour, index) => (
                <p key={index}>{hour}</p>
              ))}
            </div>
            <div>
              <p>{item.address}</p>
            </div>
          </Info>
        </div>
      ))}
    </div>
  );
};

export default Location;
